import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PartyPopper } from "lucide-react";
import api from "../../lib/api";

const ago = (iso) => {
  const d = (Date.now() - new Date(iso).getTime()) / 86400000;
  if (!Number.isFinite(d) || d < 1) return "today";
  return d < 30 ? `${Math.round(d)}d ago` : `${Math.round(d / 30)}mo ago`;
};

/* Public strip of recent first-load wins so carriers still waiting on their MC see it's real. */
export function WinWall() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/public/wins/recent").then((r) => setData(r.data)).catch(() => setData({ wins: [], count: 0 })); }, []);
  if (!data || data.wins.length === 0) return null;
  return (
    <section className="mt-10" data-testid="win-wall">
      <div className="flex flex-wrap items-center justify-between gap-2 mb-3">
        <div className="flex items-center gap-2 text-[11px] uppercase tracking-widest text-emerald-300 font-bold" data-testid="win-wall-title">
          <PartyPopper className="w-3.5 h-3.5" /> Recent first loads · {data.count} carrier{data.count === 1 ? "" : "s"} booked
        </div>
        <div className="text-[11px] text-white/45">Real carriers who finished this checklist</div>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-2 -mx-1 px-1 snap-x" data-testid="win-wall-list">
        {data.wins.map((w) => (
          <Link key={w.token} to={`/win/${w.token}`} data-testid={`win-wall-item-${w.token}`}
            className="snap-start shrink-0 w-[230px] rounded-xl border border-emerald-500/30 bg-emerald-500/[0.05] hover:bg-emerald-500/[0.1] hover:border-emerald-400/50 transition-colors p-3.5">
            <div className="text-[10px] uppercase tracking-widest text-emerald-300/80 font-bold">First load booked</div>
            <div className="text-white font-bold text-sm mt-1 truncate">{w.company || w.first_name || "New owner-operator"}</div>
            <div className="text-white/80 text-xs mt-1.5 truncate">{w.lane_from} <span className="text-[#FF5A1F]">→</span> {w.lane_to}</div>
            <div className="text-white/45 text-[11px] mt-2 flex items-center gap-1.5">
              <span className="truncate">{[w.equipment, w.days_from_active != null ? `${w.days_from_active}d after ACTIVE` : null].filter(Boolean).join(" · ")}</span>
              <span className="ml-auto shrink-0">{ago(w.booked_at)}</span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
